import { AccordionInput } from './../../../shared/accordion/accordion-input.model';

export const FAQ_LIST: AccordionInput[] = [
	{
		Title: 'Prazo de análise',
		ShortDescription: 'O pedido de aumento de limite será...',
		Description: 'O pedido de aumento de limite será analisado de 24h a 48h após a solicitação. Para pedidos de diminuição de limite, a aprovação é imediata.',
		Step: 0
	},
	{
		Title: 'Pix saque e troco',
		ShortDescription: 'Incluindo Pix saque, Pix troco e os saques...',
		Description: 'Pix saque e troco, você tem 8 transações grátis no mês, incluindo Pix saque, Pix troco e os saques tradicionais. Os estabelecimentos comerciais não podem cobrar tarifas adicionais para esses serviços.',
		Step: 1
	},
	{
		Title: 'Limite Pix saque e troco',
		ShortDescription: 'Limites máximo determinados pelo...',
		Description: 'Limites máximo determinados pelo Banco Central: R$ 3.000,00 para período diurno e R$ 1.000,00 para o período noturno.',
		Step: 2
	},
	{
		Title: 'Limite Pix troco',
		ShortDescription: 'O limite do troco, é referente à parcela...',
		Description: 'O limite do troco, é referente à parcela da transação da retirada de dinheiro.',
		Step: 3
	},
	{
		Title: 'Contato de confiança Pix',
		ShortDescription: 'Permite que seja cadastrado contatos ...',
		Description: 'Permite que seja cadastrado contatos com limite acima da transferência Pix. Esse cadastro será analisado de 24h a 48h após a solicitação.',
		Step: 4
	},
];




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limits/faq/faq.constant.ts